import React, { useState, useEffect } from 'react';
import SearchView from '../view/SearchView';

/**
 *
 * @param {Function} onSearch - function signature: searchValue => {...} | searchValue is lower cased
 * @param {String} variant - outlined (default)/underlined/contained
 */
const SearchEngine = ({
  onSearch = () => {},
  variant = 'outlined',
  disableClear,
  value = '',
  ...inputProps
}) => {
  const [searchValue, setSearchValue] = useState(value);

  useEffect(() => {
    onSearch(searchValue);
  }, [searchValue]);

  useEffect(() => {
    if (searchValue && !value) {
      setSearchValue('');
    }
  }, [value]);

  const viewProps = {
    searchValue,
    setSearchValue,
    variant,
    disableClear,
    ...inputProps
  };
  return <SearchView {...viewProps} />;
};

export default SearchEngine;
